import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LiftParameterSettingsService } from '../../services/lift-parameter-settings.service';
import { ModalComponent } from 'src/app/core/components/modal/modal.component';
import { LoginService } from 'src/app/user/services/login.service';
import { EntityListRefresh } from 'src/app/core/services/entity-list.refresh';
import { UINotificationService } from 'src/app/core/services/ui-notification.service';
import { NotificationType } from 'src/app/core/models/ui-notification.model';

@Component({
  selector: 'app-create-lift-parameter-settings',
  templateUrl: './create-lift-parameter-settings.component.html',
  styleUrls: ['./create-lift-parameter-settings.component.css']
})
export class CreateLiftParameterSettingsComponent implements OnInit {

  form = new FormGroup({});
  langs = [
    { 'lang': 'cs', 'title': 'Česky' },
    { 'lang': 'en', 'title': 'Anglicky' },
    { 'lang': 'de', 'title': 'Německy' }
  ];

  types = [
    { 'val': 1, 'title': 'String' },
    { 'val': 2, 'title': 'Int' },
    { 'val': 3, 'title': 'Enum' },
    { 'val': 4, 'title': 'IO' }
  ];

  readonly = [
    { 'val': 1, 'title': 'Ano' },
    { 'val': 0, 'title': 'Ne' }
  ];

  jsonError = false;

  napovedaInt = 'Příklad dat pro Int: { "default": 5,  "min": 0, "max": 20 }';
  napovedaString = 'Příklad dat pro String: { "default": "test",  "length": 4 }';
  napovedaEnum = 'Příklad dat pro Enum: [ "SIMPLEX", "DUPLEX"]';
  napovedaIO = 'Příklad dat pro IO: ["JÍZDA NAHORU", "JÍZDA DOLU"]';
  napovedaType = 1;

  constructor(
    private loginService: LoginService,
    private liftParameterSettingsService: LiftParameterSettingsService,
    private entityListRefresh: EntityListRefresh,
    private uiNotificationService: UINotificationService
  ) { }

  ngOnInit() {
    this.form.addControl('code', new FormControl('', Validators.required));
    this.form.addControl('lang', new FormControl(this.langs[0], Validators.required));
    this.form.addControl('title', new FormControl('', Validators.required));
    this.form.addControl('type', new FormControl(this.types[0], Validators.required));
    this.form.addControl('values', new FormControl('', Validators.required));
    this.form.addControl('isReadonly', new FormControl(this.readonly[0], Validators.required));

    this.form.controls['lang'].disable();
  }

  close(modal: ModalComponent) {
    modal.closeModal(null);
  }

  onTypeChange() {
    const type = this.form.get('type').value.val;
    this.napovedaType = type;
  }

  onSubmit(modal: ModalComponent) {
    if (this.form.valid && this.loginService.isSuperadmin()) {
      const lookupLang = [
        { twoLetterISOLanguageName: 'cs', title: this.form.get('title').value, description: this.form.get('title').value },
        { twoLetterISOLanguageName: 'de', title: this.form.get('title').value, description: this.form.get('title').value },
        { twoLetterISOLanguageName: 'en', title: this.form.get('title').value, description: this.form.get('title').value }
      ];

      this.liftParameterSettingsService.create({
        code: this.form.get('code').value,
        language: lookupLang,
        type: this.form.get('type').value.val,
        values: this.form.get('values').value,
        isReadonly: ((this.form.get('isReadonly').value.val == 1) ? true : false)
      }).subscribe(() => {
        this.entityListRefresh.refresh('lift-parameter-settings');
        this.uiNotificationService.add({
          type: NotificationType.Info,
          message: 'Parametr byl přidán'
        });
        modal.closeModal(null);
        },
        error => {
          console.log(error);
          this.jsonError = true;
        });
    }

  }

}
